import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthModule } from '~/auth/auth.module';
import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { DisplayLevelPipe } from '~/core/pipes/display-level.pipe';
import { OrganizerSharedModule } from '~/organizer/shared/shared.module';
import { ParamethorModule } from '~/paramethor/paramethor.module';

import { OrganizerActivityEditionRoutingModule } from './activity-edition-routing.module';
import { OrganizerActivityEditionAddressComponent } from './components/pages/address/address.component';
import { OrganizerActivityEditionAudienceComponent } from './components/pages/audience/audience.component';
import { OrganizerActivityEditionDescriptionComponent } from './components/pages/description/description.component';
import { OrganizerActivityEditionDurationComponent } from './components/pages/duration/duration.component';
import { OrganizerActivityEditionComponent } from './components/pages/edition/edition.component';
import { OrganizerActivityEditionEquipmentComponent } from './components/pages/equipment/equipment.component';
import { OrganizerActivityEditionPhotoComponent } from './components/pages/photo/photo.component';
import { OrganizerActivityEditionSportComponent } from './components/pages/sport/sport.component';
import { OrganizerActivityEditionTitleComponent } from './components/pages/title/title.component';
import { OrganizerActivityEditionUploadsComponent } from './components/pages/uploads/uploads.component';
import { OrganizerActivityEditionListComponent } from './components/shared/edition-list/edition-list.component';
import { OrganizerActivityEditionFormuleComponent } from './components/pages/formule/formule.component';

@NgModule({
  declarations: [
    OrganizerActivityEditionAddressComponent,
    OrganizerActivityEditionAudienceComponent,
    OrganizerActivityEditionDescriptionComponent,
    OrganizerActivityEditionDurationComponent,
    OrganizerActivityEditionComponent,
    OrganizerActivityEditionEquipmentComponent,
    OrganizerActivityEditionPhotoComponent,
    OrganizerActivityEditionSportComponent,
    OrganizerActivityEditionTitleComponent,
    OrganizerActivityEditionUploadsComponent,
    OrganizerActivityEditionFormuleComponent,

    // Shared //
    OrganizerActivityEditionListComponent,
  ],
  imports: [
    AuthModule,
    ComponentModule,
    OrganizerSharedModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    OrganizerActivityEditionRoutingModule,
    ParamethorModule,
    CommonModule,
  ],
  providers: [DisplayLevelPipe],
})
export class OrganizerActivityEditionModule {}
